/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      message: 'message',
    tele_assistance_id: 'tele_assistance_id',

};
